'use strict';

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = (function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; })();

var _isomorphicMapzenSearch = require('isomorphic-mapzen-search');

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactSelect = require('react-select');

var _reactSelect2 = _interopRequireDefault(_reactSelect);

var _throttleit = require('throttleit');

var _throttleit2 = _interopRequireDefault(_throttleit);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Geocoder = (function (_Component) {
  _inherits(Geocoder, _Component);

  function Geocoder() {
    var _Object$getPrototypeO;

    var _temp, _this, _ret;

    _classCallCheck(this, Geocoder);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_Object$getPrototypeO = Object.getPrototypeOf(Geocoder)).call.apply(_Object$getPrototypeO, [this].concat(args))), _this), _this.options = {}, _this.state = {
      value: _this.props.value || null
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(Geocoder, [{
    key: 'cacheOptions',
    value: function cacheOptions(options) {
      var _this2 = this;

      options.forEach(function (o) {
        _this2.options[o.value] = o.feature;
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (!eqOpts(nextProps.value, this.props.value)) {
        this.setState({ value: nextProps.value });
      }
    }
  }, {
    key: 'onChange',
    value: function onChange(value) {
      this.setState({ value: value });
      this.props.onChange && this.props.onChange(value && this.options[value.value]);
    }
  }, {
    key: 'shouldComponentUpdate',
    value: function shouldComponentUpdate(nextProps, nextState) {
      return !eqOpts(nextState.value, this.state.value);
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var _props = this.props;
      var apiKey = _props.apiKey;
      var boundary = _props.boundary;
      var focusLatlng = _props.focusLatlng;
      var rateLimit = _props.rateLimit;

      var loadOptions = (0, _throttleit2.default)(function (input) {
        return (0, _isomorphicMapzenSearch.search)(apiKey, input, {
          boundary: boundary,
          focusLatlng: focusLatlng
        }).then(function (geojson) {
          var options = geojson && geojson.features ? geojson.features.map(featureToOption) : [];
          _this3.cacheOptions(options);
          return { options: options };
        });
      }, rateLimit || 500);

      return _react2.default.createElement(_reactSelect2.default.Async, _extends({
        autoload: false,
        cacheAsyncResults: false,
        filterOptions: false,
        loadOptions: loadOptions,
        minimumInput: 3
      }, this.props, {
        onChange: function onChange(value) {
          return _this3.onChange(value);
        },
        value: this.state.value
      }));
    }
  }]);

  return Geocoder;
})(_react.Component);

Geocoder.propTypes = {
  apiKey: _react.PropTypes.string.isRequired,
  boundary: _react.PropTypes.object,
  focusLatlng: _react.PropTypes.any,
  onChange: _react.PropTypes.func,
  rateLimit: _react.PropTypes.number,
  value: _react.PropTypes.object
};

function eqOpts(o1, o2) {
  return o1 === o2 || o1 && o2 && o1.value === o2.value && o1.label === o2.label;
}

function featureToOption(feature) {
  return {
    feature: feature,
    label: feature.properties.label,
    value: feature.geometry.coordinates.join(',')
  };
}

module.exports = Geocoder;


/** WEBPACK FOOTER **
 ** ./~/react-select-geocoder/build/index.js
 **/